import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import '../../styles/SignupPage.css';
import { fetchSubscriptionRegisterUserApi } from '../../api/api';

const SignupPage = () => {
  const [step, setStep] = useState(1);
  const [formData, setFormData] = useState({
    username: '',
    firstname: '',
    lastname: '',
    mobilenumber: '',
    password: '',
    address1: '',
    address2: '',
    address3: '',
    country: '',
    postcode: '',
    subscriptionid: '1',
  });
  const [subscriptionformData, setSubscriptionFormData] = useState({
    username: '',
    firstname: '',
    lastname: '',
    mobilenumber: '',
    password: '',
    address1: '',
    address2: '',
    address3: '',
    country: '',
    postcode: '',
    subscriptionid: '1',
  });
  const [paymentSuccess, setPaymentSuccess] = useState(false);
  const [error, setError] = useState('');
  const [fieldErrors, setFieldErrors] = useState({});
  const navigate = useNavigate();
  const [successMessage, setSuccessMessage] = useState("");
  const [paypalLoading, setPaypalLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value
    }));
  };

  const validateStep = () => {
    const errors = {};
    const { username, password } = formData;

    if (step === 1) {
      if (!username.trim()) errors.username = 'Email is required';
      else if (!/^\S+@\S+\.\S+$/.test(username))
        errors.username = 'Invalid email format';

      if (!password.trim()) errors.password = 'Password is required';
  }

    setFieldErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const handleNext = () => {
    if (validateStep()) {
      setStep((prev) => prev + 1);
    }
  };

  const handleBack = () => {
    setStep((prev) => prev - 1);
  };

  const handleSubmit = (e) => {
  e.preventDefault();
  if (validateStep()) {
    (async () => {
      try {
        console.log("Final submitted data:", formData);
        console.log("Final submitted data:", subscriptionformData);
        
        const res = await fetchSubscriptionRegisterUserApi(formData);
        if (res.statuscode === 200) {
          setError("");
          setSuccessMessage(res.message || "Please check your email — an activation link has been sent.");
          // Redirect to login after 4 seconds
          setTimeout(() => {
            navigate("/login");
          }, 4000);
        } else {
          if(res.statuscode === 400){
            setError("Registration failed. Please try again.");
          }
          else{
          setError(res.message || "Registration failed. Please try again.");
          }
        }
      } catch (err) {
        setError("An error occurred while registering your account.");
      }
    })();
  }
  };

  const renderPaypalButtons = () => {
    window.paypal
      .Buttons({
        fundingSource: window.paypal.FUNDING.PAYPAL,
        funding: {
          disallowed: [window.paypal.FUNDING.CARD],
        },
        createSubscription: (data, actions) =>
          actions.subscription.create({
            plan_id: "P-6VU7597709697014PNCJRCRI", 
          }),
        onApprove: async (data, actions) => {
          try {
            const subscriptionId = data.subscriptionID;
            console.log("PayPal Subscription ID:", subscriptionId);

            // Save subscription ID in formData
            // setFormData((prev) => ({
            //   ...prev,
            //   paypalSubscriptionId: subscriptionId,
            // }));

            setSubscriptionFormData({
              ...formData,               
              paypalSubscriptionId: subscriptionId,
            });

            // Verify subscription with backend
            const response = await fetch("/api/verify-subscription", {
              method: "POST",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify({ subscriptionId }),
            });

            const result = await response.json();
            console.log("Verification result:", result);

            if (result.status === "ACTIVE") {
              setPaymentSuccess(true);
            } else {
              setError(`Subscription status: ${result.status}`);
            }
          } catch (err) {
            console.error(err);
            setError("Payment verification failed.");
          }
        },
        onError: (err) => {
          console.error(err);
          setError("Payment failed. Try again.");
        },
      })
      .render("#paypal-button-container");
  };

  useEffect(() => {
    if (step === 3 && formData.subscriptionid === '2') {
      const container = document.getElementById('paypal-button-container');
      if (container) {
        container.innerHTML = '';
      }

      if (window.paypal) {
        setPaypalLoading(true)
        renderPaypalButtons();
        setPaypalLoading(false)
      } else {
        // Load PayPal script if not already present
        const script = document.createElement('script');
        script.id = 'paypal-script';
        script.src =
          'https://www.paypal.com/sdk/js?client-id=AWr_vGCRtFX1KmtKSwSv3eA2opJ9Y1m__35EAugbMWW7KQH7_V-7eM5KntsXOQSLgZFW3niICUsQli0E&vault=true&intent=subscription';
        script.onload = renderPaypalButtons;
        document.body.appendChild(script);
      }
    }
  }, [step, formData.subscriptionid]);

  

  const steps = ['Info', 'Address', 'Payment'];
  const renderStepper = () => (
    <div className="custom-stepper">
      {steps.map((label, index) => {
        const currentStep = index + 1;
        return (
          <div key={label} className="step-wrapper">
            <div className={`step-circle ${step >= currentStep ? 'active' : ''}`}>
              {currentStep}
            </div>
            <div className={`step-label ${step >= currentStep ? 'active' : ''}`}>
              {label}
            </div>
            {index < steps.length - 1 && <div className="step-line" />}
          </div>
        );
      })}
    </div>
  );


  return (
    <div className="signup-container">
      <form className="signup-form" onSubmit={handleSubmit}>
        {renderStepper()}
        {successMessage && <p className="success-message">{successMessage}</p>}
        {error && <p className="error">{error}</p>}
        {step === 1 && (
          <>
            {/* <h3>Step 1: Personal Details</h3> */}
            <div className="form-group">
              <label>Email (Username) *</label>
              <input
                type="email"
                name="username"
                placeholder="Enter your email"
                value={formData.username}
                onChange={handleChange}
                autoComplete="email"
                className={fieldErrors.username ? 'input-error' : ''}
              />
              {fieldErrors.username && <p className="field-error">{fieldErrors.username}</p>}
            </div>
            <div className="form-group">
              <label>First Name</label>
              <input
                type="text"
                name="firstname"
                placeholder="Enter first name"
                value={formData.firstname}
                onChange={handleChange}
              />
            </div>
            <div className="form-group">
              <label>Last Name</label>
              <input
                type="text"
                name="lastname"
                placeholder="Enter last name"
                value={formData.lastname}
                onChange={handleChange}
              />
            </div>
            <div className="form-group">
              <label>Mobile Number</label>
              <input
                type="tel"
                name="mobilenumber"
                placeholder="Enter mobile number"
                value={formData.mobilenumber}
                onChange={handleChange}
              />
            </div>
            <div className="form-group password-group">
              <label>Password *</label>
              <div className="password-wrapper">
                <input
                  type={showPassword ? "text" : "password"}
                  name="password"
                  placeholder="Enter password"
                  value={formData.password}
                  onChange={handleChange}
                  className={fieldErrors.password ? "input-error" : ""}
                />
                <span
                  className="password-toggle"
                  onClick={() => setShowPassword((prev) => !prev)}
                >
                  {showPassword ? (
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" height="20" width="20" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" 
                        d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" 
                        d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 
                          2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 
                          0-8.268-2.943-9.542-7z" />
                    </svg>
                    
                  ) : (
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" height="20" width="20" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" 
                        d="M2 12C3.5 7 7.5 4 12 4s8.5 3 10 8c-1.5 5-5.5 8-10 8s-8.5-3-10-8z" />
                      <circle cx="12" cy="12" r="3" strokeWidth="2" stroke="currentColor" fill="none"/>
                      <line x1="4" y1="20" x2="20" y2="4" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                    </svg>
                  )}
                </span>
              </div>
              {fieldErrors.password && <p className="field-error">{fieldErrors.password}</p>}
            </div>
            {/* <div className="form-group">
              <label>Confirm Password *</label>
              <input
                type="password"
                name="confirmPassword"
                placeholder="Confirm password"
                value={formData.confirmPassword}
                onChange={handleChange}
                className={fieldErrors.confirmPassword ? 'input-error' : ''}
              />
              {fieldErrors.confirmPassword && <p className="field-error">{fieldErrors.confirmPassword}</p>}
            </div> */}
            <div className='signup-btn-content'>
              <button type="button" onClick={handleNext}>Next →</button>
            </div>
          </>
        )}

        {step === 2 && (
          <>
            {/* <h3>Step 2: Address Details</h3> */}
            {['address1', 'address2', 'address3', 'country', 'postcode'].map((field, i) => (
              <div className="form-group" key={field}>
                <label>{`${
                  ['Address Line 1', 'Address Line 2', 'Address Line 3', 'Country', 'Postcode'][i]
                }`}</label>
                <input
                  type="text"
                  name={field}
                  placeholder={`Enter ${['address line 1', 'address line 2', 'address line 3', 'country', 'postcode'][i]}`}
                  value={formData[field]}
                  onChange={handleChange}
                />
              </div>
              
            ))}
            <div className='signup-btn-content_2_3'>
              <button type="button" onClick={handleBack}>← Back</button>
              <button type="button" onClick={handleNext}>Next →</button>
            </div>
          </>
        )}

        {step === 3 && (
          <>
            {/* <h3>Step 3: Payment</h3> */}
            <div className="form-group">
              <label>Subscription Plan</label>
              <select
                name="subscriptionid"
                value={formData.subscriptionid}
                onChange={handleChange}
              >
                <option value='1'>Free</option>
                <option value="2">Pro (1 month free, then $9.99/month)</option>
              </select>
            </div>
              {formData.subscriptionid === '2' && (
              <div style={{ textAlign: 'center' }}>
                {paypalLoading ? (
                  <div className="loader">Loading PayPal...</div>
                ) : (
                  <div id="paypal-button-container" style={{ marginBottom: '1rem' }}></div>
                )}
                {!paymentSuccess && !paymentSuccess && <p>Your Payment successfully</p>}
                {!paypalLoading && !paypalLoading && <p>Complete payment to proceed</p>}
              </div>
            )} 
            <div className='signup-btn-content_2_3'>
              <button type="button" onClick={handleBack}>← Back</button>
              <button type="submit">Submit</button>
            </div>
          </>
        )}

        {/* {step === 4 && (
          <>
            <div className="thank-you">
              <h2>Thank You for Signing Up!</h2>
              <p>Your account has been created successfully.</p>
              <button className="thank-you-btn"type="submit">Finish</button>
            </div>
          </>
        )} */}
      </form>
    </div>
  );
};

export default SignupPage;
